module.exports = __webpack_public_path__ + "img/comments.687ffd39.svg";